import update from 'react-addons-update';
import {
  SET_IS_TOGGLE_ON,
  SET_DRIVER_BLACKLIST,
  ORDER_VEHICLE_TYPE,
  ORDER_PASSENGER_COURT,
  ORDER_TUNNEL,
  ORDER_PICKUP_TIME,
  ORDER_NEED_OVER_6FT,
  ORDER_REMOVE_NET,
  ORDER_NEED_CART,
  ORDER_CART_COUNT,
  ORDER_NEED_CARRY,
  ORDER_NEED_NEW_CAR,
  ORDER_NEED_PET,
  ORDER_NEED_WASTE,
  ORDER_PAY_BY_RECEIVER,
  ORDER_ADD_ADDRESS,
  ORDER_UPDATE_ADDRESS,
  ORDER_ADD_IMAGE,
  ORDER_UPDATE_IMAGE,
  ORDER_REMOVE_IMAGE,
  ORDER_ID_DETAIL,
  ORDER_PRICE_BREAKDOWN_DETAIL,
  ORDER_REMARK,
  ORDER_COUPON,
  IS_CLICK_CONFIRM_ORDER,
  IS_VALID_ORDER,
  ADD_UPLOADED_ORDER_IMAGE,
  UPDATE_ORDER_DETAIL_INFO,
  ADD_ORDER_DETAIL_INFO,
  INIT_ORDER_DETAIL_INFO,
  IS_SHOW_COUPON,
  IS_UPLOADED_CLIENT_PHOTO,
} from '../constants';

export default function order(state = null, action) {
  if (state === null) {
    return {
      isToggleOn: true,
      address: [],
      images: [],
      vehicle: '',
      passenger_count: 0,
      tunnel: 'any',
      pickup_time: '0',
      need_over_6ft: false,
      cart_count: 1,
      need_cart: false,
      remove_net: 'half',
      need_carry: false,
      need_new_car: false,
      need_pet: false,
      need_waste: false,
      pay_by_receiver: false,
      order_id_detail: 0,
      driverBlacklistResponse: {},
      coupon_code: null,
      orderPriceBreakdownDetail: {
        extra_message: '',
      },
      remark: '',
      isClickConfirmOrder: false,
      isValidOrder: true,
      isShowCoupon: false,
      isUploadedClientPhoto: false,
      client_uploads: [],
      orderDetailInfo: {},
    };
  }

  switch (action.type) {
    case SET_IS_TOGGLE_ON:
      return {
        ...state,
        isToggleOn: !state.isToggleOn,
      };
    case ORDER_VEHICLE_TYPE:
      return {
        ...state,
        vehicle: action.payload,
      };
    case ORDER_ADD_ADDRESS:
      return {
        ...state,
        address: [...state.address, action.payload],
      };
    case ORDER_UPDATE_ADDRESS:
      return update(state, {
        address: {
          [action.index]: { $set: action.payload },
        },
      });
    case ORDER_ADD_IMAGE:
      return {
        ...state,
        images: [...state.images, action.payload],
      };
    case ORDER_UPDATE_IMAGE:
      return update(state, {
        images: {
          [action.index]: { $set: action.payload },
        },
      });
    case ORDER_REMOVE_IMAGE:
      return update(state, {
        images: {
          $splice: [[action.index, 1]],
        },
      });
    case ORDER_PASSENGER_COURT:
      return {
        ...state,
        passenger_count: action.payload,
      };
    case ORDER_TUNNEL:
      return {
        ...state,
        tunnel: action.payload,
      };
    case ORDER_PICKUP_TIME:
      return {
        ...state,
        pickup_time: action.payload,
      };
    case ORDER_NEED_OVER_6FT:
      return {
        ...state,
        need_over_6ft: action.payload,
      };
    case ORDER_REMOVE_NET:
      return {
        ...state,
        remove_net: action.payload,
      };
    case ORDER_CART_COUNT:
      return {
        ...state,
        cart_count: action.payload,
      };
    case ORDER_NEED_CART:
      return {
        ...state,
        need_cart: action.payload,
      };
    case ORDER_NEED_CARRY:
      return {
        ...state,
        need_carry: action.payload,
      };
    case ORDER_NEED_NEW_CAR:
      return {
        ...state,
        need_new_car: action.payload,
      };
    case ORDER_NEED_PET:
      return {
        ...state,
        need_pet: action.payload,
      };
    case ORDER_NEED_WASTE:
      return {
        ...state,
        need_waste: action.payload,
      };
    case ORDER_PAY_BY_RECEIVER:
      return {
        ...state,
        pay_by_receiver: action.payload,
      };
    case ORDER_ID_DETAIL:
      return {
        ...state,
        order_id_detail: action.payload,
      };
    case SET_DRIVER_BLACKLIST:
      return {
        ...state,
        driverBlacklistResponse: action.payload,
      };
    case ORDER_PRICE_BREAKDOWN_DETAIL:
      return {
        ...state,
        orderPriceBreakdownDetail: action.payload,
      };
    case ORDER_REMARK:
      return {
        ...state,
        remark: action.payload,
      };
    case ORDER_COUPON:
      return {
        ...state,
        coupon_code: action.payload,
      };
    case IS_CLICK_CONFIRM_ORDER:
      return {
        ...state,
        isClickConfirmOrder: action.payload,
      };
    case IS_VALID_ORDER:
      return {
        ...state,
        isValidOrder: action.payload,
      };
    case IS_UPLOADED_CLIENT_PHOTO:
      return {
        ...state,
        isUploadedClientPhoto: action.payload,
      };
    case IS_SHOW_COUPON:
      return {
        ...state,
        isShowCoupon: action.payload,
      };
    case INIT_ORDER_DETAIL_INFO:
      return update(state, {
        orderDetailInfo: { $set: action.payload },
      });
    case ADD_UPLOADED_ORDER_IMAGE:
      return update(state, {
        client_uploads: { $push: action.payload },
      });
    case UPDATE_ORDER_DETAIL_INFO:
      // replace whole elements
      if (action.service === null) {
        return update(state, {
          orderDetailInfo: {
            $set: action.payload,
          },
        });
      } else if (action.service2 === null) {
        return update(state, {
          orderDetailInfo: {
            [action.service]: {
              $set: action.payload,
            },
          },
        });
      }
      return update(state, {
        orderDetailInfo: {
          [action.service]: {
            [action.service2]: {
              $set: action.payload,
            },
          },
        },
      });
    case ADD_ORDER_DETAIL_INFO:
      return update(state, {
        orderDetailInfo: {
          [action.service]: {
            $set: action.payload,
          },
        },
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/order.js